export const TOGGLE_EMPLOYEE_MODAL = "TOGGLE_EMPLOYEE_MODAL";

export const GET_BASIC_INFO = "GET_BASIC_INFO";
export const GET_BASIC_INFO_SUCCESS = "GET_BASIC_INFO_SUCCESS";
export const GET_BASIC_INFO_FAILURE = "GET_BASIC_INFO_FAILURE";

export const UPDATE_BASIC_INFO = "UPDATE_BASIC_INFO";
export const UPDATE_BASIC_INFO_SUCCESS = "UPDATE_BASIC_INFO_SUCCESS";
export const UPDATE_BASIC_INFO_FAILURE = "UPDATE_BASIC_INFO_FAILURE";

export const GET_USER_ACCOUNT_INFO = "GET_USER_ACCOUNT_INFO";
export const GET_USER_ACCOUNT_INFO_SUCCESS = "GET_USER_ACCOUNT_INFO_SUCCESS";
export const GET_USER_ACCOUNT_INFO_FAILURE = "GET_USER_ACCOUNT_INFO_FAILURE";

export const UPDATE_USER_ACCOUNT_INFO = "UPDATE_USER_ACCOUNT_INFO";
export const UPDATE_USER_ACCOUNT_INFO_SUCCESS =
  "UPDATE_USER_ACCOUNT_INFO_SUCCESS";
export const UPDATE_USER_ACCOUNT_INFO_FAILURE =
  "UPDATE_USER_ACCOUNT_INFO_FAILURE";

export const GET_EMPLOYEEMENT_INFO = "GET_EMPLOYEEMENT_INFO";
export const GET_EMPLOYEEMENT_INFO_SUCCESS = "GET_EMPLOYEEMENT_INFO_SUCCESS";
export const GET_EMPLOYEEMENT_INFO_FAILURE = "GET_EMPLOYEEMENT_INFO_FAILURE";

export const UPDATE_EMPLOYEEMENT_INFO = "UPDATE_EMPLOYEEMENT_INFO";
export const UPDATE_EMPLOYEEMENT_INFO_SUCCESS =
  "UPDATE_EMPLOYEEMENT_INFO_SUCCESS";
export const UPDATE_EMPLOYEEMENT_INFO_FAILURE =
  "UPDATE_EMPLOYEEMENT_INFO_FAILURE";

export const GET_PERMISSIONS = "GET_PERMISSIONS";
export const GET_PERMISSIONS_SUCCESS = "GET_PERMISSIONS_SUCCESS";
export const GET_PERMISSIONS_FAILURE = "GET_PERMISSIONS_FAILURE";

export const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";
export const UPDATE_PERMISSIONS_SUCCESS = "UPDATE_PERMISSIONS_SUCCESS";
export const UPDATE_PERMISSIONS_FAILURE = "UPDATE_PERMISSIONS_FAILURE";

export const GET_LINE_INFO = "GET_LINE_INFO";
export const GET_LINE_INFO_SUCCESS = "GET_LINE_INFO_SUCCESS";
export const GET_LINE_INFO_FAILURE = "GET_LINE_INFO_FAILURE";

export const UPDATE_LINE_INFO = "UPDATE_LINE_INFO";
export const UPDATE_LINE_INFO_SUCCESS = "UPDATE_LINE_INFO_SUCCESS";
export const UPDATE_LINE_INFO_FAILURE = "UPDATE_LINE_INFO_FAILURE";

export const GET_WORKING_INFO = "GET_WORKING_INFO";
export const GET_WORKING_INFO_SUCCESS = "GET_WORKING_INFO_SUCCESS";
export const GET_WORKING_INFO_FAILURE = "GET_WORKING_INFO_FAILURE";

export const UPDATE_WORKING_INFO = "UPDATE_WORKING_INFO";
export const UPDATE_WORKING_INFO_SUCCESS = "UPDATE_WORKING_INFO_SUCCESS";
export const UPDATE_WORKING_INFO_FAILURE = "UPDATE_WORKING_INFO_FAILURE";

export const GET_ROLE_INFO = "GET_ROLE_INFO";
export const GET_ROLE_INFO_SUCCESS = "GET_ROLE_INFO_SUCCESS";
export const GET_ROLE_INFO_FAILURE = "GET_ROLE_INFO_FAILURE";

export const UPDATE_ROLE_INFO = "UPDATE_ROLE_INFO";
export const UPDATE_ROLE_INFO_SUCCESS = "UPDATE_ROLE_INFO_SUCCESS";
export const UPDATE_ROLE_INFO_FAILURE = "UPDATE_ROLE_INFO_FAILURE";

export const GET_WORKING_LOCATIONS = "GET_WORKING_LOCATIONS";
export const GET_WORKING_LOCATIONS_SUCCESS = "GET_WORKING_LOCATIONS_SUCCESS";
export const GET_WORKING_LOCATIONS_FAILURE = "GET_WORKING_LOCATIONS_FAILURE";

export const UPDATE_LOCATIONS = "UPDATE_LOCATIONS";
export const UPDATE_LOCATIONS_SUCCESS = "UPDATE_LOCATIONS_SUCCESS";
export const UPDATE_LOCATIONS_FAILURE = "UPDATE_LOCATIONS_FAILURE";

export const GET_ONBOARDING_STEPS = "GET_ONBOARDING_STEPS";
export const GET_ONBOARDING_STEPS_SUCCESS = "GET_ONBOARDING_STEPS_SUCCESS";
export const GET_ONBOARDING_STEPS_FAILURE = "GET_ONBOARDING_STEPS_FAILURE";

export const GET_STEP_DETAILS = "GET_STEP_DETAILS";
export const GET_STEP_DETAILS_SUCCESS = "GET_STEP_DETAILS_SUCCESS";
export const GET_STEP_DETAILS_FAILURE = "GET_STEP_DETAILS_FAILURE";

export const SET_FIELDS = "SET_FIELDS";

export const TOGGLE_APPROVE_MODAL = "TOGGLE_APPROVE_MODAL";
export const TOGGLE_STEP_APPROVE_MODAL = "TOGGLE_STEP_APPROVE_MODAL";
export const TOGGLE_STEP_FILE_MODAL = "TOGGLE_STEP_FILE_MODAL";
export const TOGGLE_VIEW_FILE_MODAL = "TOGGLE_VIEW_FILE_MODAL";

export const APPROVE_FIELD = "APPROVE_FIELD";
export const APPROVE_FIELD_SUCCESS = "APPROVE_FIELD_SUCCESS";
export const APPROVE_FIELD_FAILURE = "APPROVE_FIELD_FAILURE";

export const GET_PERSONAL_INFO = "GET_PERSONAL_INFO";
export const GET_PERSONAL_INFO_SUCCESS = "GET_PERSONAL_INFO_SUCCESS";
export const GET_PERSONAL_INFO_FAILURE = "GET_PERSONAL_INFO_FAILURE";

export const UPDATE_PERSONAL_INFO = "UPDATE_PERSONAL_INFO";
export const UPDATE_PERSONAL_INFO_SUCCESS = "UPDATE_PERSONAL_INFO_SUCCESS";
export const UPDATE_PERSONAL_INFO_FAILURE = "UPDATE_PERSONAL_INFO_FAILURE";

export const GET_DOCUMENTS = "GET_DOCUMENTS";
export const GET_DOCUMENTS_SUCCESS = "GET_DOCUMENTS_SUCCESS";
export const GET_DOCUMENTS_FAILURE = "GET_DOCUMENTS_FAILURE";

export const GET_HOLIDAY_INFO = "GET_HOLIDAY_INFO";
export const GET_HOLIDAY_INFO_SUCCESS = "GET_HOLIDAY_INFO_SUCCESS";
export const GET_HOLIDAY_INFO_FAILURE = "GET_HOLIDAY_INFO_FAILURE";

export const GET_LEAVES = "GET_LEAVES";
export const GET_LEAVES_SUCCESS = "GET_LEAVES_SUCCESS";
export const GET_LEAVES_FAILURE = "GET_LEAVES_FAILURE";

export const UPDATE_HOLIDAY_INFO = "UPDATE_HOLIDAY_INFO";
export const UPDATE_HOLIDAY_INFO_SUCCESS = "UPDATE_HOLIDAY_INFO_SUCCESS";
export const UPDATE_HOLIDAY_INFO_FAILURE = "UPDATE_HOLIDAY_INFO_FAILURE";

export const GET_PAYROLL_INFO = "GET_PAYROLL_INFO";
export const GET_PAYROLL_INFO_SUCCESS = "GET_PAYROLL_INFO_SUCCESS";
export const GET_PAYROLL_INFO_FAILURE = "GET_PAYROLL_INFO_FAILURE";

export const UPDATE_PAYROLL_INFO = "UPDATE_PAYROLL_INFO";
export const UPDATE_PAYROLL_INFO_SUCCESS = "UPDATE_PAYROLL_INFO_SUCCESS";
export const UPDATE_PAYROLL_INFO_FAILURE = "UPDATE_PAYROLL_INFO_FAILURE";

export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAILURE = "DOWNLOAD_FILE_FAILURE";

export const DELETE_FILE = "DELETE_FILE";
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS";
export const DELETE_FILE_FAILURE = "DELETE_FILE_FAILURE";

export const GET_VERSION_HISTORY = "GET_VERSION_HISTORY";
export const GET_VERSION_HISTORY_SUCCESS = "GET_VERSION_HISTORY_SUCCESS";
export const GET_VERSION_HISTORY_FAILURE = "GET_VERSION_HISTORY_FAILURE";

export const SEND_REVISION_MAIL = "SEND_REVISION_MAIL";
export const SEND_REVISION_MAIL_SUCCESS = "SEND_REVISION_MAIL_SUCCESS";
export const SEND_REVISION_MAIL_FAILURE = "SEND_REVISION_MAIL_FAILURE";

export const GET_DOC_VERSIONS = "GET_DOC_VERSIONS";
export const GET_DOC_VERSIONS_SUCCESS = "GET_DOC_VERSIONS_SUCCESS";
export const GET_DOC_VERSIONS_FAILURE = "GET_DOC_VERSIONS_FAILURE";

export const SEND_DOC_MAIL = "SEND_DOC_MAIL";
export const SEND_DOC_MAIL_SUCCESS = "SEND_DOC_MAIL_SUCCESS";
export const SEND_DOC_MAIL_FAILURE = "SEND_DOC_MAIL_FAILURE";

export const GET_DOC_CORRECTIONS = "GET_DOC_CORRECTIONS";
export const GET_DOC_CORRECTIONS_SUCCESS = "GET_DOC_CORRECTIONS_SUCCESS";
export const GET_DOC_CORRECTIONS_FAILURE = "GET_DOC_CORRECTIONS_FAILURE";

export const UPLOAD_NEW_DOC = "UPLOAD_NEW_DOC";
export const UPLOAD_NEW_DOC_SUCCESS = "UPLOAD_NEW_DOC_SUCCESS";
export const UPLOAD_NEW_DOC_FAILURE = "UPLOAD_NEW_DOC_FAILURE";

export const GET_STEP_HISTORY = "GET_STEP_HISTORY";
export const GET_STEP_HISTORY_SUCCESS = "GET_STEP_HISTORY_SUCCESS";
export const GET_STEP_HISTORY_FAILURE = "GET_STEP_HISTORY_FAILURE";

export const TOGGLE_STEP_HISTORY_MODAL = "TOGGLE_STEP_HISTORY_MODAL";

export const SET_STEP_TITLE = "SET_STEP_TITLE";

export const UPDATE_ONBOARDING_DATA = "UPDATE_ONBOARDING_DATA";

export const GET_ADDITIONAL_DOCUMENTS = "GET_ADDITIONAL_DOCUMENTS";
export const GET_ADDITIONAL_DOCUMENTS_SUCCESS =
  "GET_ADDITIONAL_DOCUMENTS_SUCCESS";
export const GET_ADDITIONAL_DOCUMENTS_FAILURE =
  "GET_ADDITIONAL_DOCUMENTS_FAILURE";

export const TOGGLE_ADDITIONAL_DOCUMENT_MODAL =
  "TOGGLE_ADDITIONAL_DOCUMENT_MODAL";

export const GET_DOCS_HISTORY = "GET_DOCS_HISTORY";
export const GET_DOCS_HISTORY_SUCCESS = "GET_DOCS_HISTORY_SUCCESS";
export const GET_DOCS_HISTORY_FAILURE = "GET_DOCS_HISTORY_FAILURE";

export const EDIT_VERSION_FILE = "EDIT_VERSION_FILE";
export const EDIT_VERSION_FILE_SUCCESS = "EDIT_VERSION_FILE_SUCCESS";
export const EDIT_VERSION_FILE_FAILURE = "EDIT_VERSION_FILE_FAILURE";
